$(window).on('js-onload', function(){

    function persistTo(address, type) {
        address = $.extend({}, address);

        this.html( Handlebars.templates['address'](address) );

        $(window).trigger('persistAddress', [address, type]);
    }

    function populateBillingAddress(address) {
        var $billing = $('#bill-address:first');

        // ignore if billing has data
        if($billing.find('.modify:first').find(':text').filter(function(){ return !!this.value; }).length > 0) {
            return;
        }

        var $address = $billing.find('.persisted:first .address:first');

        persistTo.call($address, address, 'bill');

        $.each(address, function(key, value) {
            if(key === 'state_province') return;
            if(key === 'country') {
              $('#bill_country').val(address.country);
              $('#bill_country').trigger('change', function() {
                $('#bill_state_province').val(address.state_province);
              });
              return;
            }
            $('#bill_' + key).val(value);
        });

        $billing.addClass('confirmed');
    }

    if($('#ship-address').hasClass('confirmed')) {
        var startAddress = stripFromKeys($('#ship-address').find('.modify :input').serializeJSON(), 'ship_');
        loadShippingMethods(startAddress);
    }

    $('.guest-address')
        .on('click', '.guest-change', function(event){
            var $guest = $(event.delegateTarget);
            $guest.removeClass('confirmed');

            $(window).trigger('stall.panel', [$guest.data('addressType')]);

            $(window).trigger($guest.data('addressType')+'.alteraddress');

            if(window.shipRateXHR) {
                window.shipRateXHR.abort();
                window.shipRateXHR = null;
            }
        })
        .addressBook({
            buttonSelector: '.guest-confirm:first',
            formSelector: '.modify:first',
            save: function(address) {
                var that = this;

                persistTo.call(that.$element.find('.persisted:first .address:first'), address, that.addressType);

                $(window).trigger('release.panel', [that.addressType]);

                if(that.addressType == 'ship') {
                    $(window).trigger('shipping.setaddress', [address]);
                    populateBillingAddress(address);
                }

                that.$button.enable().removeClass('loading');

                that.$element.addClass('confirmed');

                $('html, body').delay(250).animate({
                    scrollTop: that.$element.closest('section').offset().top - 50
                }, 350);

                that._cleanup(true);
            },
            saveModal: function(event) {
                var that = this;

                var value = $('[name="verify_addr"]:checked', event.delegateTarget).val();
                var updated = that._address( ('recommend' === value) ? that.validated : {} );

                $.each(updated, function(key, value){
                    $('#'+that.addressType+'_'+key).val(value);
                });

                // var address = stripFromKeys($inputs.serializeJSON(), that.addressType+'_');
                persistTo.call(that.$element.find('.persisted:first .address:first'), updated, that.addressType);

                $(window).trigger('release.panel', [that.addressType]);

                if(that.addressType == 'ship') {
                    $(window).trigger('shipping.setaddress', [updated]);
                    populateBillingAddress(updated);
                }

                that.$element.addClass('confirmed');
                that.$modal.modal('hide');

                $('html, body').delay(250).animate({
                    scrollTop: that.$element.closest('section').offset().top - 50
                }, 350);

                that._cleanup(true);
            }
        });
});
